import {css} from '@emotion/react'

const cssCollapseContent = css({
    display: 'grid',
    overflow: 'hidden',
})

const cssCollapseContentCollapsed = css({
    width: 0,
    height: 0,
})

export const CollapseContent = ({isExpanded, ...props}) => {
    const csss = [cssCollapseContent]

    if (! isExpanded) {
        csss.push(cssCollapseContentCollapsed)
    }

    return (
        <div
            css={csss}
            {...props}
        >
        </div>
    )
}
